import { motion } from "framer-motion";
import { Car, BedDouble, Plane, Sun, MessageCircle } from "lucide-react";
import { waLink } from "./data";
import { Reveal, Overline } from "./Reveal";

const PASOS = [
  { icon: Car, title: "Salís en auto", text: "Manejás desde tu ciudad hasta Foz do Iguaçu. Te pasamos la ruta y las paradas recomendadas." },
  { icon: BedDouble, title: "Noche en Foz", text: "Según el horario de salida del vuelo, incluimos 1 noche de hotel en Foz para que viajes descansado." },
  { icon: Plane, title: "Volás al Nordeste", text: "Desde Foz tomás tu vuelo a Natal, Maceió, Salvador, Recife u otro destino." },
  { icon: Sun, title: "Disfrutás tu destino", text: "Hospedaje, traslados y paseos organizados. A la vuelta, lo mismo en orden inverso." },
];

export const FozCombo = () => (
  <section id="foz-vuelo" data-testid="foz-combo-section" className="bg-arena pb-24 lg:pb-36">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-16">
      <div className="mb-14 grid gap-6 lg:grid-cols-12 lg:items-end">
        <Reveal className="lg:col-span-7">
          <Overline>Paquete combinado</Overline>
          <h2 className="font-display text-4xl font-extrabold leading-[0.95] tracking-tight text-mar sm:text-6xl">
            Auto hasta Foz, <span className="font-serif-i font-normal text-barro">vuelo al Nordeste.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-5">
          <p className="text-base leading-relaxed text-tinta/75 md:text-lg">
            Una forma muy elegida para llegar a las playas del Nordeste. Así funciona, paso a paso:
          </p>
        </Reveal>
      </div>
      <div className="relative grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        <motion.div aria-hidden="true" className="absolute left-0 right-0 top-[52px] hidden h-[3px] origin-left rounded-full bg-gradient-to-r from-barro via-sol to-brasil lg:block"
          initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 1.8, ease: [0.16, 1, 0.3, 1] }} />
        {PASOS.map(({ icon: Icon, title, text }, i) => (
          <Reveal key={title} delay={0.12 * i}>
            <motion.div whileHover={{ y: -6 }} data-testid={`foz-step-${i + 1}`}
              className="relative h-full rounded-[2rem] bg-white p-7 shadow-[0_25px_50px_-30px_rgba(27,42,92,0.45)]">
              <div className="flex items-center justify-between">
                <span className={`flex h-14 w-14 items-center justify-center rounded-2xl ${i === 1 ? "bg-sol text-mar" : i === 2 ? "bg-mar text-white" : i === 3 ? "bg-brasil text-white" : "bg-barro text-white"}`}>
                  <Icon className="h-6 w-6" />
                </span>
                <span className="font-serif-i text-4xl text-mar/40">0{i + 1}</span>
              </div>
              <h3 className="mt-6 font-display text-2xl font-bold text-mar">{title}</h3>
              <p className="mt-3 text-base leading-relaxed text-tinta/75">{text}</p>
            </motion.div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <a data-testid="foz-combo-whatsapp" href={waLink("¡Hola Jaha Brasilpe! Quiero cotizar el paquete auto hasta Foz + vuelo al Nordeste.")} target="_blank" rel="noopener noreferrer"
          className="mt-10 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-7 py-4 font-bold text-mar transition-transform duration-300 hover:-translate-y-1">
          <MessageCircle className="h-5 w-5" /> Cotizar Foz + vuelo
        </a>
      </Reveal>
    </div>
  </section>
);
